var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStore = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.158,
    height: 39.845,
    viewBox: "0 0 11.154 10.542",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.778 -156.169)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.353,
    d: "M36.55 156.59h-3.286v.804h3.285zm4.134 9.703v-7.006c-.299-.05-3.567-.032-3.706.017v.798h.234l2.306.001c.055 0 .11-.003.165.004.111.015.173.082.173.194 0 .111-.059.183-.169.2-.067.01-.137.006-.205.006l-2.266.001c-.08 0-.159.007-.24.011v.827H39.514c.055 0 .11-.001.165.004.111.011.176.076.178.188.002.109-.052.186-.162.207-.06.011-.123.007-.185.007h-2.306c-.073 0-.147.007-.223.01v.825H39.568c.208 0 .293.063.288.205-.005.138-.095.2-.298.202h-.124l-2.245.001c-.071 0-.143.008-.21.012v.82h2.54c.048 0 .097-.004.144 0 .125.012.192.082.194.196.001.11-.07.192-.186.208-.054.007-.11.003-.165.003h-2.525v.83h2.548c.055 0 .112-.005.165.005.097.02.158.08.162.184.005.11-.048.187-.154.213-.059.014-.123.007-.185.007H37.19c-.072 0-.144.006-.212.009v.81zm-8.66-8.465v8.462h4.534v-.274-6.775c0-.357.026-.384.386-.384h.659c.059-.001.118-.009.18-.013v-1.016zm9.082 8.474h.441c.28 0 .382.054.385.2.003.153-.097.209-.374.209H31.033c-.174-.005-.254-.067-.255-.199-.002-.131.083-.205.248-.209.123-.003.247 0 .37 0 .06-.001.12-.007.206-.011v-.271-8.218-.144c.008-.18.07-.245.253-.249.261-.005.522 0 .783-.002.06 0 .12-.007.204-.012v-.272c0-.233-.003-.467.001-.7.003-.187.064-.245.247-.254l.103-.001h3.44c.29 0 .332.043.332.335v.905h.881c.326 0 .359.035.36.37v1.066c.09.005.162.012.235.012h2.286c.34 0 .379.038.379.377v6.776z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 35.373 161.966)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-.194.015-.39-.003-.583-.031-.327-.27-.556-.561-.56a.576.576 0 00-.581.54c-.024.407-.023.817-.001 1.224.018.34.247.539.563.544.338.005.556-.205.582-.582C.013.39.001.194.001 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 32.49 163.38)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .174-.007.349.001.523.017.314.181.505.497.544.311.037.604-.149.63-.466.039-.443.035-.893.001-1.336-.024-.309-.336-.547-.609-.503-.297.047-.497.221-.515.54C-.008-.466.002-.233.002 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 33.73 163.403)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .214-.019.43.004.641.035.316.239.484.55.493.313.01.55-.153.576-.461a8.8 8.8 0 00.005-1.339c-.021-.309-.246-.48-.548-.509-.285-.027-.55.216-.584.534-.023.212-.004.427-.004.641z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 32.894 164.873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-.193.021-.388-.004-.578-.044-.327-.244-.517-.579-.529-.294-.01-.537.215-.555.546-.022.404-.017.81-.004 1.214.011.34.206.538.545.552.343.014.544-.189.59-.513C.025.466 0 .231 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 34.134 159.062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-.213.022-.43-.004-.64-.041-.331-.288-.532-.599-.508-.311.023-.521.19-.537.507-.022.426-.018.854-.001 1.281.014.324.244.476.537.512.293.037.56-.19.599-.512C.021.43 0 .213 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 33.73 164.85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .212-.02.427.005.636.036.306.226.482.536.506a.541.541 0 00.596-.505c.03-.422.028-.848.002-1.271-.021-.329-.233-.523-.568-.539-.298-.014-.534.209-.568.537C-.018-.426 0-.212 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 35.374 159.064)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-.194.007-.389-.002-.582-.017-.343-.201-.538-.545-.559-.315-.02-.575.179-.598.508-.028.425-.027.855.002 1.28.022.317.31.545.603.512.3-.034.509-.198.533-.518C.009.428-.004.213-.004 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 33.73 160.503)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .213-.019.429.004.64.036.32.253.476.559.481.31.005.542-.158.566-.471a9.04 9.04 0 00.002-1.337c-.022-.311-.253-.474-.558-.491-.304-.017-.543.205-.575.537-.02.212-.004.427-.004.641z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 32.49 161.948)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .194-.008.388.002.582.016.318.192.499.507.531.318.032.595-.154.622-.478a8.066 8.066 0 00-.002-1.337c-.025-.303-.266-.47-.566-.492-.29-.021-.528.218-.56.554C-.017-.429 0-.213 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 35.373 160.517)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-.194.015-.39-.003-.582-.032-.345-.249-.547-.559-.55-.323-.002-.562.187-.582.526a9.94 9.94 0 00.005 1.28.54.54 0 00.612.489c.299-.038.507-.195.523-.522C.006.428-.002.214-.002 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 34.967 163.399)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .194-.016.39.003.582.033.334.258.539.568.543.324.005.552-.181.574-.529.025-.406.022-.816.001-1.222a.586.586 0 00-.562-.561C.299-1.189.04-.958.006-.64-.016-.429.002-.213.002 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 34.134 161.955)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-.213.021-.429-.004-.64-.038-.324-.298-.547-.586-.538-.292.009-.536.237-.553.568-.02.407-.022.817.002 1.223.02.334.263.532.582.519.315-.013.514-.181.554-.492C.021.43 0 .214 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 34.967 164.847)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .193-.01.387.002.579.021.341.224.524.553.553a.524.524 0 00.587-.508c.028-.423.025-.851.002-1.274a.559.559 0 00-.573-.532.585.585 0 00-.567.545C-.015-.426 0-.212 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 32.49 159.053)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .194-.015.389.003.581.032.331.27.563.563.549.309-.013.537-.19.564-.488.039-.442.038-.892.002-1.334-.027-.323-.311-.511-.62-.479-.316.033-.491.216-.508.531-.012.213-.003.427-.003.64z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 32.49 160.495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 .193-.007.387.001.581.015.329.227.49.523.517.306.027.561-.138.592-.438.048-.459.044-.929.008-1.39-.025-.306-.262-.47-.574-.461-.311.009-.513.177-.543.494-.021.23-.004.465-.004.697z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/store.4f9e5e1ff8517848107ad8570e6cd23c.svg";